/*@flow*/
import useStoreState from 'lib/useStoreState';
import * as I from 'immutable';

// Using a hook to keep API consistent. Later we might want to
// use the global context instead of state() function.
export default function useQueryParams(): any {
  const { s } = useStoreState({ s: '$query' });
  return s || I.Map();
}
